import { useTreatments } from '@splitsoftware/splitio-react'

interface Config {
  startAt: string
}

export const useSplitWithConfig = (key: string, accountCreationDate: number) => {
  const SplitTreatment = useTreatments([key])

  const configString = SplitTreatment[key].config
  let config: Config | null = null
  if (configString) {
    try {
      config = JSON.parse(configString) as Config
    } catch (error) {
      console.error('Failed to parse config:', error)
    }
  }
  const accountCreationDateInMilliSeconds = accountCreationDate * 1000
  const startAtTimestamp = config?.startAt ? Number(config.startAt) : null
  const isFlagActive =
    startAtTimestamp !== null && startAtTimestamp < accountCreationDateInMilliSeconds

  const isFeatureEnabled = SplitTreatment[key].treatment === 'on'

  return isFeatureEnabled && isFlagActive
}
